import { ComponentType, SVGProps } from 'react'

import { Icon } from '@/shared/ui/icon'

import cl from './ServiceElement.module.scss'

interface ServiceElementProps {
	icon: ComponentType<SVGProps<SVGSVGElement>>
	text: string
	onClick?: () => void
}

export const ServiceElement = (props: ServiceElementProps) => {
	const { icon, text, onClick } = props

	return (
		<div className={cl.service} onClick={onClick}>
			<div className={cl.service__icon}>
				<Icon icon={icon} width={24} height={24} />
			</div>
			<p className={cl.service__title}>{text}</p>
		</div>
	)
}
